import PropTypes from "prop-types"
import React from "react"

import { InlineText } from "../../../Typography/Typography"

const pluralise = (count, plural, singular) => (count === 1 ? singular : plural)

function AdditionalInfo({
  numberOfBeds,
  numberOfBedsInSingleRooms,
  numberOfBedsInDoubleRooms,
  numberOfBedsWithEnsuite,
  dateOpened,
  className,
}) {
  const allSingleRooms =
    numberOfBeds > 0 && numberOfBeds === numberOfBedsInSingleRooms
  const allEnsuiteRooms =
    numberOfBeds > 0 && numberOfBeds === numberOfBedsWithEnsuite
  const showNumberOfBeds = numberOfBeds !== null && !allSingleRooms
  const ensuiteNumberDisplay =
    numberOfBedsWithEnsuite === 0 ? "No" : numberOfBedsWithEnsuite

  const values = [
    showNumberOfBeds &&
      `${numberOfBeds} ${pluralise(numberOfBeds, "beds", "bed")}`,
    numberOfBedsInSingleRooms !== null &&
      `${numberOfBedsInSingleRooms} single ${pluralise(
        numberOfBedsInSingleRooms,
        "rooms",
        "room",
      )}`,
    numberOfBedsInDoubleRooms &&
      `${numberOfBedsInDoubleRooms} ${pluralise(
        numberOfBedsInDoubleRooms,
        "beds in double rooms",
        "bed in a double room",
      )}`,
    numberOfBedsWithEnsuite !== null && allEnsuiteRooms && "All en-suite",
    numberOfBedsWithEnsuite !== null &&
      !allEnsuiteRooms &&
      `${ensuiteNumberDisplay} en-suite ${pluralise(
        numberOfBedsWithEnsuite,
        "rooms",
        "room",
      )}`,
    dateOpened && `Opened in ${new Date(dateOpened).getFullYear()}`,
  ]

  const valuesWithData = values.filter((x) => x)

  return (
    <InlineText className={className}>{valuesWithData.join(" • ")}</InlineText>
  )
}

AdditionalInfo.propTypes = {
  numberOfBeds: PropTypes.number,
  numberOfBedsInSingleRooms: PropTypes.number,
  numberOfBedsInDoubleRooms: PropTypes.number,
  numberOfBedsWithEnsuite: PropTypes.number,
  dateOpened: PropTypes.string,
  className: PropTypes.string,
}

AdditionalInfo.defaultProps = {
  numberOfBeds: undefined,
  numberOfBedsInSingleRooms: undefined,
  numberOfBedsInDoubleRooms: undefined,
  numberOfBedsWithEnsuite: undefined,
  dateOpened: undefined,
  className: undefined,
}

export default AdditionalInfo
